/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from '../../constants/translation';

class BookingSectionTab extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    isSticky: PropTypes.bool,
    loading: PropTypes.bool,
    onTabChange: PropTypes.func,
    tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
    tabID: PropTypes.number,
  }
  static defaultProps = {
    isMobile: false,
    tabID: 1,
  }
  static getPropsToState = (props) => {
    const bookingID = props.bookingID || '';
    const isSticky = props.isSticky;
    const loading = props.loading;
    const tabs = props.tabs || [];
    const tabID = props.tabID;
    return {
      bookingID,
      isSticky,
      loading,
      tabs,
      tabID,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingSectionTab.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = BookingSectionTab.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleTabClick = (e, tab) => {
    const { isSticky } = this.state;
    e.preventDefault();
    this.setState({ tabID: tab.id }, () => {
      if (this.props.onTabChange) {
        this.props.onTabChange({
          ...tab,
          isSticky,
        });
      }
    });
  }
  render() {
    const { isMobile, t } = this.props;
    const { isSticky, loading, tabs, tabID } = this.state;
    const filteredTabs = tabs.filter(tab => !tab.disabled);
    return (
      <div>
        {isSticky ?
          <Button.Group className="booking_section_tabs sticky" compact fluid size={isMobile ? 'mini' : 'tiny'} disabled={loading}>
            {
              filteredTabs.map((tab, idx) => (
                <Button key={idx} active={tabID === tab.id} onClick={e => this.handleTabClick(e, tab)} style={isMobile ? { fontSize: '0.65rem' } : {}}>
                  {t(tab.title).toUpperCase()}
                </Button>
              ))
            }
          </Button.Group>
          :
          (isMobile ?
            <Button.Group className="booking_section_tabs" compact fluid size="mini" disabled={loading}>
              {
                filteredTabs.map((tab, idx) => (
                  <Button key={idx} active={tabID === tab.id} onClick={e => this.handleTabClick(e, tab)}>
                    {t(tab.title).toUpperCase()}
                  </Button>
                ))
              }
            </Button.Group>
            :
            <Button.Group className="booking_section_tabs" fluid disabled={loading}>
              {
                filteredTabs.map((tab, idx) => (
                  <Button key={idx} active={tabID === tab.id} onClick={e => this.handleTabClick(e, tab)}>
                    <Header as="h4" inverted={tabID === tab.id}>
                      {t(tab.title).toUpperCase()}
                      <Header.Subheader>{t(tab.description)}</Header.Subheader>
                    </Header>
                  </Button>
                ))
              }
            </Button.Group>
          )
        }
      </div>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(BookingSectionTab);



// WEBPACK FOOTER //
// ./src/components/Bookings/BookingSectionTab.jsx